import OrdersTableContent from './ordersTableContent';
import NotConnectedContent from './notConnectedContent';

import { OrderT, OrdersViewTabs } from 'types';

import './OrdersTable.scss';

interface Props {
  currentTab?: OrdersViewTabs;
  orders: OrderT[];
  handlerCancelOrder: Function;
  isConnected: boolean;
  isOrdersLoading: boolean;
  isCancelOrderLoading: boolean;
  isCancelSignOrderLoading: boolean;
  selectedOrderId?: string;
}

const OrdersTable = ({
  currentTab = OrdersViewTabs.OpenOrders,
  orders,
  handlerCancelOrder,
  isConnected,
  isOrdersLoading,
  isCancelOrderLoading,
  isCancelSignOrderLoading,
  selectedOrderId,
}: Props) => {
  return (
    <div className={`orders-table ${currentTab}`}>
      <div className="orders-table-header order-row">
        <span className="orders-table-coll-name time">{_t('Time', 'VIEW_ORDERS.COLUMN_TIME')}</span>
        <span className="orders-table-coll-name trade">{_t('Pair', 'VIEW_ORDERS.COLUMN_PAIR')}</span>
        <span className="orders-table-coll-name amount">{_t('Amount', 'VIEW_ORDERS.COLUMN_AMOUNT')}</span>
        <span className="orders-table-coll-name amount">{_t('Type', 'VIEW_ORDERS.COLUMN_TYPE')}</span>
        <span className="orders-table-coll-name price">{_t('Price', 'VIEW_ORDERS.COLUMN_PRICE')}</span>
        <span className="orders-table-coll-name filled">{_t('Status', 'VIEW_ORDERS.COLUMN_STATUS')}</span>
        <span className="orders-table-coll-name"></span>
      </div>
      <div className="orders-table-orders-container">
        {isConnected ? (
          <OrdersTableContent
            currentTab={currentTab}
            orders={orders}
            handlerCancelOrder={handlerCancelOrder}
            isOrdersLoading={isOrdersLoading}
            isCancelOrderLoading={isCancelOrderLoading}
            isCancelSignOrderLoading={isCancelSignOrderLoading}
            selectedOrderId={selectedOrderId}
          />
        ) : (
          <NotConnectedContent />
        )}
      </div>
    </div>
  );
};

export default OrdersTable;
